export const SET_ERROR = "SET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SET_EXPIRE = "SET_EXPIRE";
export const CLEAR_EXPIRE = "CLEAR_EXPIRE";